import axios from "axios";
import { API } from "../../utils";
const instance = axios.create();

export const getFormats = async () => {
  return instance.get(`${API}/format`);
};
